export default "/77695522dae322948778df846b87b54f.jpg";